import React, { useState, useEffect, Component } from "react";
import axios from "axios";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import TableView from "../TableView";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const SupplierInvoice = () => {
  const [baseUrl, setBaseUrl] = useState("http://mol.evolve-demo.com/api/");
  const [pageComponent, setPageComponent] = useState("supplierinvoice");
  const [bookingNOList, setBookingNOList] = useState(undefined);
  const [bookindNo, setBookindNo] = useState("");
  const [supplierList, setSupplierList] = useState(undefined);
  const [supplier, setSupplier] = useState("");
  const [supName, setSupName] = useState("");
  const [rateList, setRateList] = useState(undefined);
  const [rate, setRate] = useState("");
  const [currencyList, setcurrencyList] = useState(undefined);
  const [currency, setcurrency] = useState("");
  const [eXGRate, setEXGRate] = useState("");
  const [volume, setvolume] = useState("");
  const [amount, setAmount] = useState("");
  const [totAmount, setTotAmount] = useState("");
  const [supINVNO, setSupINVNO] = useState("");
  const [iNVDate, setINVDate] = useState("");
  const [postDate, setPostDate] = useState("");
  const [period, setPeriod] = useState("");
  const [paymentTermList, setPaymentTermList] = useState(undefined);
  const [paymentTerm, setPaymentTerm] = useState("");
  const [transactionClassList, setTransactionClassList] = useState(undefined);
  const [transactionClass, setTransactionClass] = useState("");
  const [paymentMode, setPaymentMode] = useState("");
  const [transactionType, setTransactionType] = useState("");
  const [remark, setRemark] = useState("");

  const [tableItems, setTableItems] = useState([]);
  const [selectedItemTableLIst, setSelectedItemTableLIst] = useState(undefined);

  useEffect(() => {
    fetch(`${baseUrl}${pageComponent}/filterBookingNumber`)
      .then((response) => response.json())
      .then((data) => {
        setBookingNOList(data.filterBookingNumber);
      })
      .catch((error) => {
        alert(error());
      });
  }, []);

  useEffect(() => {
    fetch(`${baseUrl}${pageComponent}/getsuppliernames`)
      .then((response) => response.json())
      .then((data) => {
        setSupplierList(data.supplierNames);
      })
      .catch((error) => {
        alert(error());
      });
  }, []);

  useEffect(() => {
    fetch(`${baseUrl}${pageComponent}/getrate`)
      .then((response) => response.json())
      .then((data) => {
        setRateList(data.rate_details);
      })
      .catch((error) => {
        alert(error());
      });
  }, []);

  useEffect(() => {
    fetch(`${baseUrl}${pageComponent}/getcurrency`)
      .then((response) => response.json())
      .then((data) => {
        setcurrencyList(data.currency_details);
      })
      .catch((error) => {
        alert(error());
      });
  }, []);

  useEffect(() => {
    fetch(`${baseUrl}${pageComponent}/getpayterm`)
      .then((response) => response.json())
      .then((data) => {
        setPaymentTermList(data.payterm);
      })
      .catch((error) => {
        alert(error());
      });
  }, []);

  useEffect(() => {
    fetch(`${baseUrl}${pageComponent}/gettransactionclass`)
      .then((response) => response.json())
      .then((data) => {
        setTransactionClassList(data.transclass);
      })
      .catch((error) => {
        alert(error());
      });
  }, []);

  const passBookingNUM = (value) => {
    setBookindNo(value);
    let SupplierName = bookingNOList.find((item) => item.BookingNo === value);
    let bookingID = SupplierName.id;
    if (bookingID) {
      axios
        .get(
          `http://mol.evolve-demo.com/api/bookingcosting/show/${bookingID}`,
          {
            method: "GET",
            mode: "cors",
          }
        )
        .then((response) => {
          console.log(response.data.booking.booking_header_table_detail);
          setSelectedItemTableLIst(
            response.data.booking.booking_header_table_detail
          );
          // setCost(response.data.booking.booking_detail[0][0].Cost);
          // selectCurruncy(response.data.booking[0].Currency);
        })

        .catch((error) => {
          console.error(error);
        });
    }
  };

  const passSupplier = (value) => {
    setSupplier(value);
    supplierList.forEach((supplier) => {
      if ((supplier.id = value)) {
        setSupName(supplier.SupplierName);
        console.log(supplier.SupplierName);
      }
    });
  };

  const saveSupINvoice = () => {
    let SupplierName = supplierList.find((item) => item.Vendor_id === supplier);
    const inputData = {
      BookingNo: bookindNo,
      SupplierCode: supplier,
      CurrCode: currency,
      ExRate: eXGRate,
      Volume: volume,
      Amount: amount,
      UserId: "8",
      SuppInvNo: supINVNO,
      SuppInvDate: iNVDate,
      Period: period,
      InsertDate: "2022-5-9",
      CreateDate: "2022-5-9",
      ACCTID: "ACCTID",
      ACCTDESC: "ACCTDESC",
      PaymentMode: paymentMode,
      RateCode: rate,
      RateCode: rate,
      SupplierName: SupplierName.Vendor_name ? SupplierName.Vendor_name : "",
    };
    console.log(inputData);
    axios
      .post(`${baseUrl}${pageComponent}/store`, inputData, {
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
        },
      })
      .then((response) => {
        toast.success("Successfully Save Data ! ", {
          position: toast.POSITION.TOP_RIGHT,
        });
        setTimeout(window.location.reload.bind(window.location), 2000);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const columns = [
    "SuppName",
    "Rate",
    "Currency",
    "ExRate",
    "Volume",
    "Amount",
    "totalAmount",
    "Remark",
    "SupInvNo",
    "SupInvDate",
    "AccPacACCTID",
    "AccPacAccTDESC",
    "period",
    "NBT",
    "VAT",
    "PaymentTerm",
    "TransactionClass",
    "TransactionType",
    "PaymentMode",
  ];

  const setTableValue = async () => {
    appndTableValue();
  };

  const appndTableValue = async () => {
    let SupplierName = supplierList.find((item) => item.Vendor_id === supplier);
    const updateTableVal = {
      SuppName: SupplierName.Vendor_name ? SupplierName.Vendor_name : "",
      Rate: rate,
      Currency: currency,
      ExRate: eXGRate,
      Volume: volume,
      Amount: amount,
    };
    const updateTableLIst = tableItems.concat(updateTableVal);
    setTableItems(updateTableLIst);
  };
  return (
    <Container>
      <ToastContainer autoClose={2000} />
      <Row>
        <Col>
          <Form className="mt-3 bottom-border pb-3">
            <Row>
              <Col>
                <Form.Group className="mb-3" controlId="formGroupEmail">
                  <Form.Label>Booking No</Form.Label>
                  <Form.Select
                    aria-label="Default select"
                    value={bookindNo}
                    onChange={(e) => passBookingNUM(e.target.value)}
                  >
                    <option value=""></option>
                    {bookingNOList !== undefined
                      ? bookingNOList.map((bookingItem, id) => (
                          <option value={bookingItem.BookingNo} key={id}>
                            {bookingItem.BookingNo}
                          </option>
                        ))
                      : ""}
                  </Form.Select>
                  <Form.Check
                    type="checkbox"
                    className="mt-1"
                    label="All Booling"
                  />
                </Form.Group>
              </Col>
              <Col>
                <Form.Group className="mb-3" controlId="formGroupEmail">
                  <Form.Label>InvNo</Form.Label>
                  <Form.Select aria-label="Default select" disabled="true">
                    <option value=""></option>
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col>
                <Form.Group className="mb-3" controlId="formGroupEmail">
                  <Form.Label>From</Form.Label>
                  <Form.Select aria-label="Default select" disabled="true">
                    <option value=""></option>
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col>
                <Form.Group className="mb-3" controlId="formGroupEmail">
                  <Form.Label>To</Form.Label>
                  <Form.Select aria-label="Default select" disabled="true">
                    <option value=""></option>
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col className="mt-2">
                <Button className="mt-4" variant="primary" disabled="true">
                  Search
                </Button>
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Group className="mb-2" controlId="formGroupEmail">
                  <Form.Label>Supplier {supName}</Form.Label>
                  <Form.Select
                    aria-label="Default select"
                    value={supplier}
                    onChange={(e) => passSupplier(e.target.value)}
                  >
                    <option value=""></option>
                    {selectedItemTableLIst !== undefined
                      ? selectedItemTableLIst.map((tableitem, id) => (
                          <option value={tableitem.SupplierCode} key={id}>
                            {tableitem.SupplierName}
                          </option>
                        ))
                      : supplierList !== undefined
                      ? supplierList.map((supItem, id) => (
                          <option value={supItem.Vendor_id} key={id}>
                            {supItem.Vendor_name}
                          </option>
                        ))
                      : ""}
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col>
                <Form.Group className="mb-2" controlId="formGroupEmail">
                  <Form.Label>Rate {rate}</Form.Label>
                  <Form.Select
                    aria-label="Default select"
                    value={rate}
                    onChange={(e) => setRate(e.target.value)}
                  >
                    {selectedItemTableLIst !== undefined
                      ? selectedItemTableLIst.map((tableitem, id) => (
                          <option value={tableitem.RateCode} key={id}>
                            {tableitem.Rate}
                          </option>
                        ))
                      : rateList !== undefined
                      ? rateList.map((rateItem, id) => (
                          <option value={rateItem.RateCode} key={id}>
                            {rateItem.RateDesc}
                          </option>
                        ))
                      : ""}
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col>
                <Form.Group className="mb-2">
                  <Form.Label>Exg Rate {eXGRate}</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder=""
                    autoComplete="off"
                    name="exgrate"
                    value={eXGRate}
                    onChange={(e) => setEXGRate(e.target.value)}
                  />
                </Form.Group>
              </Col>
              <Col>
                <Form.Group className="mb-2">
                  <Form.Label>Volume{volume}</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder=""
                    autoComplete="off"
                    name="exgrate"
                    value={volume}
                    onChange={(e) => setvolume(e.target.value)}
                  />
                </Form.Group>
              </Col>
              <Col>
                <Form.Group className="mb-2">
                  <Form.Label>Amount{amount}</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder=""
                    autoComplete="off"
                    name="exgrate"
                    value={amount}
                    onChange={(e) => setAmount(e.target.value)}
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Group className="mb-3" controlId="formGroupEmail">
                  <Form.Label>Currency</Form.Label>
                  <Form.Select
                    aria-label="Default select"
                    value={currency}
                    onChange={(e) => setcurrency(e.target.value)}
                  >
                    <option value=""></option>
                    {currencyList !== undefined
                      ? currencyList.map((curItem, id) => (
                          <option value={curItem.CurrCode} key={id}>
                            {curItem.CurrDesc}
                          </option>
                        ))
                      : ""}
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col>
                <Form.Group className="mb-3">
                  <Form.Label>Tot Amount{totAmount}</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder=""
                    autoComplete="off"
                    name="exgrate"
                    value={totAmount}
                    onChange={(e) => setTotAmount(e.target.value)}
                  />
                </Form.Group>
              </Col>
              <Col>
                <Form.Group className="mb-3">
                  <Form.Label>Sup Inv No</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder=""
                    autoComplete="off"
                    name="exgrate"
                    value={supINVNO}
                    onChange={(e) => setSupINVNO(e.target.value)}
                  />
                </Form.Group>
              </Col>
              <Col>
                <Form.Group className="mb-3">
                  <Form.Label>Sup Inv Date</Form.Label>
                  <Form.Control
                    type="date"
                    placeholder=""
                    autoComplete="off"
                    name="date"
                    value={iNVDate}
                    onChange={(e) => setINVDate(e.target.value)}
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Group className="mb-3">
                  <Form.Label>Post Date</Form.Label>
                  <Form.Control
                    type="date"
                    placeholder=""
                    autoComplete="off"
                    name="date"
                    value={postDate}
                    onChange={(e) => setPostDate(e.target.value)}
                  />
                </Form.Group>
              </Col>
              <Col>
                <Form.Group className="mb-3" controlId="formGroupEmail">
                  <Form.Label>Period</Form.Label>
                  <Form.Select
                    aria-label="Default select"
                    value={period}
                    onChange={(e) => setPeriod(e.target.value)}
                  >
                    <option value=""></option>
                    <option value="6">06</option>
                    <option value="7">07</option>
                    <option value="8">08</option>
                    <option value="9">09</option>
                    <option value="10">10</option>
                    <option value="11">11</option>
                    <option value="12">12</option>
                    <option value="13">13</option>
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col>
                <Form.Group className="mb-3" controlId="formGroupEmail">
                  <Form.Label>Payment Term</Form.Label>
                  <Form.Select
                    aria-label="Default select"
                    value={paymentTerm}
                    onChange={(e) => setPaymentTerm(e.target.value)}
                  >
                    <option value=""></option>
                    {paymentTermList !== undefined
                      ? paymentTermList.map((paytermItem, id) => (
                          <option value={paytermItem.Code} key={id}>
                            {paytermItem.PaymentTerm}
                          </option>
                        ))
                      : ""}
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col>
                <Form.Group className="mb-3" controlId="formGroupEmail">
                  <Form.Label>Transaction Class</Form.Label>
                  <Form.Select
                    aria-label="Default select"
                    value={transactionClass}
                    onChange={(e) => setTransactionClass(e.target.value)}
                  >
                    {transactionClassList !== undefined
                      ? transactionClassList.map((transClassItem, id) => (
                          <option
                            value={transClassItem.TransactionClass}
                            key={id}
                          >
                            {transClassItem.TransactionClass}
                          </option>
                        ))
                      : ""}
                  </Form.Select>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Group className="mb-3" controlId="formGroupEmail">
                  <Form.Label>Payment Mode</Form.Label>
                  <Form.Select
                    aria-label="Default select"
                    value={paymentMode}
                    onChange={(e) => setPaymentMode(e.target.value)}
                  >
                    <option value=""></option>
                    <option value="001">CHEQUE</option>
                    <option value="002">CASH</option>
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col>
                <Form.Group className="mb-3" controlId="formGroupEmail">
                  <Form.Label>Transaction Type</Form.Label>
                  <Form.Select
                    aria-label="Default select"
                    value={transactionType}
                    onChange={(e) => setTransactionType(e.target.value)}
                  >
                    <option value=""></option>
                    <option value="001">Tax Invoice</option>
                    <option value="002">Zero Tax Invoice</option>
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col>
                <Form.Group className="mb-3">
                  <Form.Label>Remark {remark}</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder=""
                    autoComplete="off"
                    name="exgrate"
                    value={remark}
                    onChange={(e) => setRemark(e.target.value)}
                  />
                </Form.Group>
              </Col>
              <Col className="text-center mt-4">
                <Button
                  className="ms-3"
                  variant="primary"
                  onClick={setTableValue}
                >
                  ADD
                </Button>

                <Button className="ms-3" variant="primary">
                  Delete
                </Button>
              </Col>
            </Row>
          </Form>
        </Col>
      </Row>
      <Row className="mt-4">
        <Col>
          <TableView data={tableItems} columns={columns} />
        </Col>
      </Row>
      <Row>
        <Col className="text-end mt-3">
          <Button className="ms-3" variant="primary" onClick={saveSupINvoice}>
            Save
          </Button>
          <Button className="ms-3" variant="primary">
            New
          </Button>
          <Button className="ms-3" variant="primary">
            Credit Note
          </Button>
          <Button className="ms-3" variant="primary">
            Print
          </Button>
          <Button className="ms-3" variant="primary" type="submit">
            Cancel
          </Button>
        </Col>
        <Col>
          <Form.Group className="mb-3">
            <Form.Label>Total Amount</Form.Label>
          </Form.Group>
        </Col>
      </Row>
    </Container>
  );
};

export default SupplierInvoice;
